import { LineChartOutlined, MinusOutlined } from '@ant-design/icons';
import ParentSize from '@visx/responsive/lib/components/ParentSize';
import { Button, Card, Col, Row, Spin, Tooltip } from 'antd';
import React, { useState } from 'react';
import { CompanyActivity } from '../../models/company-activity-interface';
import ActivityChart from './ActivityChart';
import { useCookies } from 'react-cookie';

interface ActiviyChartCardProps {
  companyActivity: CompanyActivity[] | undefined;
  pageIsLoading: boolean;
  chartIsLoading: boolean;
}

enum UserActivityChartSetting {
  Hidden = 0,
  Visible = 1,
}

const activityChartCookie = 'hideShowActivityChart';

export default function ActiviyChartCard({
  companyActivity,
  pageIsLoading,
  chartIsLoading
}: ActiviyChartCardProps) {
  const [cookies, setCookie] = useCookies(['sessionUserName']);
  const [chartSetting, setChartSetting] = useState<UserActivityChartSetting>(
    cookies[activityChartCookie] !== undefined
      ? parseInt(cookies[activityChartCookie]) : UserActivityChartSetting.Visible
  );

  const updateChartSetting = () => {
    if (chartSetting === UserActivityChartSetting.Hidden) {
      setChartSetting(UserActivityChartSetting.Visible);
      setCookie(activityChartCookie, UserActivityChartSetting.Visible, {path: "/"});
    } else {
      setChartSetting(UserActivityChartSetting.Hidden);
      setCookie(activityChartCookie, UserActivityChartSetting.Hidden, {path: "/"});
    }
  };

  const hasActivity = !!companyActivity ? companyActivity.filter(x => x.activityCount > 0).length > 0 : false

  return (
    <>
      <Tooltip
        overlay={
          chartSetting === UserActivityChartSetting.Hidden
            ? 'Show activity chart'
            : 'Hide activity chart'
        }
      >
        <Button
          type='primary'
          shape='circle'
          icon={
            chartSetting === UserActivityChartSetting.Hidden ? (
              <LineChartOutlined />
            ) : (
              <MinusOutlined />
            )
          }
          onClick={() => updateChartSetting()}
          style={{
            marginBottom: -50,
            zIndex: 100,
            position: 'absolute',
            top: -14,
            right: 25,
          }}
        />
      </Tooltip>
      <Card
        style={hasActivity || chartSetting === UserActivityChartSetting.Hidden ? {
          height: chartSetting === UserActivityChartSetting.Hidden ? 0 : 360,
          borderWidth: chartSetting === UserActivityChartSetting.Hidden ? 0 : 1,
        } : {}}
      >
        <Spin
          spinning={
            chartIsLoading && chartSetting === UserActivityChartSetting.Visible
          }
        >
            {!!companyActivity && hasActivity ? 
            <div
            style={{
              height:
                chartSetting === UserActivityChartSetting.Hidden ? 0 : 360,
            }}
          >
            <ParentSize>
              {({ width, height }) => (
                <ActivityChart
                  height={height}
                  width={width}
                  data={companyActivity}
                  isLoading={pageIsLoading || chartIsLoading}
                />
              )}
            </ParentSize>
          </div>
            : !!companyActivity ? <Row align='middle' justify='center'><Col span={24}><LineChartOutlined /> No activity in past 7 days</Col></Row> : null }
        </Spin>
      </Card>
    </>
  );
}
